export default "__VITE_ASSET__7655d5c2__"